import { render } from "./InputTextareaChat.vue?vue&type=template&id=1fe52f3c&scoped=true"
import script from "./InputTextareaChat.vue?vue&type=script&lang=js"
export * from "./InputTextareaChat.vue?vue&type=script&lang=js"

import "./InputTextareaChat.vue?vue&type=style&index=0&id=1fe52f3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe52f3c"]])

export default __exports__